
import { Component, OnInit, OnDestroy, AfterViewInit, OnChanges, Input, Optional, Inject, ChangeDetectorRef, SimpleChanges } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { StorageHelper, Utils } from "@app/_helpers";
import { getTradingViewCustomThemes } from "@app/_helpers/tradingview-theme.utilities";
import { EventsService, SymbolSearchService, ConfigurationService, QuoteStoreService, QUOTE_UPDATE_TYPE, MarketSocketService } from "@app/_shared/providers";
import { ChartingService } from "@app/_shared/providers/charting/charting.service";
import { MarketWatch } from "@app/app.models";
import { WidgetViewMode, UserTypes, Instrument } from "@app/app.structs";
import { MarketWatchService } from "@app/modules/trading/modules/market-watch/providers/market-watch/market-watch.service";
import { WidgetStateService } from "@app/modules/trading/modules/widget/_providers";
import { throttle } from "echarts";
import { ToastrService } from "ngx-toastr";
import { UserInfo } from "os";
import { Subscription, fromEvent, interval } from "rxjs";
import { share } from "rxjs/operators";
import { ChartData, ChartSelection, ChartingFilters, CandleUpdateObj, ChartDataResponse, ChartUpdate } from "./chart.interface";
import { ChartLibrary, ChartIntervals, ChartTypes, ChartUpdateType } from "./chart.structs";
import { ChartTemplate } from "./symbol-chart.template";
import { ResolutionString, widget } from '../../../../libs/charting_library/charting_library/';
import { TradingViewDatafeed } from "./tradingview.datafeed";
import { ChartUtilities } from "@app/_helpers/chart-utilities";
import { MarketIDMap } from "@app/_shared/shared.enums";


@Component({
    selector: 'app-chart',
    templateUrl: './chart.component.html',
    styleUrls: [
        './chart.component.scss'
    ]
})
export class ChartComponent implements OnInit, OnDestroy, AfterViewInit, OnChanges {
    isMarketPictureOpened = false;
    chartUpdate: any;
    chartUpdateSubscribtion: Subscription;
    chartSelectectionSubscription: Subscription;
    widgetViewModes = WidgetViewMode;
    @Input() symbolId: number;
    @Input() securityId: number;
    @Input() marketId: string;
    @Input() isIndex: boolean;
    @Input() mwSymbol: MarketWatch;

    chartData: ChartData = {
        data: [],
        xAxis: [],
        volumeData: [],
        allCloses: [],
        ohlc: [],
    };

    selectedLayout = '';

    chartSelection: ChartSelection = {
        high: '',
        low: '',
        open: '',
        close: '',
        volume: '',
        line: ''
    };

    chartFilters: ChartingFilters;
    chartTypeLoaded = false;
    chartCache: any;

    candleOptions: any;
    public currentChartingLibrary: string = ChartLibrary.tradingView;
    selectedInterval = ChartIntervals['1h'];
    public chartLibrary;
    chartIntervalEnums = ChartIntervals;
    chartTypesEnum = ChartTypes;
    tradingViewOptions: any = {};
    selectedSymbol: MarketWatch = null;
    selectedChart = ChartTypes.candle;
    userTypeEnum = UserTypes;
    currentViewMode = WidgetViewMode.DEFAULT;
    // widgetName = FluidWidgets.chart;
    initOpts: any;
    widgetsState: any;
    tvChartContainer = 'tv_chart_container';
    openedInNewTab = false;
    responseId: number;
    private subscriptions = new Subscription();

    constructor(
        @Optional() @Inject(MAT_DIALOG_DATA) private dialogData,
        private _eventsService: EventsService,
        private _chartService: ChartingService,
        private _toast: ToastrService,
        private _changeDetectorRef: ChangeDetectorRef,
        private _symbolSearchService: SymbolSearchService,
        private _dialog: MatDialog,
        private _widgetService: WidgetStateService,
        private _router: Router,
        private marketwatchService: MarketWatchService,
        private remoteConfigService: ConfigurationService,
        private quoteService: QuoteStoreService,
        private marketService: MarketSocketService
    ) {

        this.chartLibrary = ChartLibrary;
        // this._cacheService.getSelectedView().then((res: SelectedView) => {
        //     this.selectedLayout = res.selectedView;
        // });
        // this._socket.setEventService(this._eventsService);
        this.initOpts = {
            height: 0.5 * window.innerHeight
        }
        // if (Utils.storageHelper.widget) {
        //     if (Utils.storageHelper.widget['chart'] === WidgetViewMode.MINIMISED) {
        //         this.currentViewMode = WidgetViewMode.MINIMISED;
        //     }
        //     if ((Utils.storageHelper.widget['marketPicture'] === WidgetViewMode.MAXIMISED) &&
        //         (Utils.storageHelper.widget['chart'] === WidgetViewMode.DEFAULT)) {
        //         this.currentViewMode = WidgetViewMode.MINIMISED;
        //     }
        // }
        if (dialogData && dialogData.isDialog) {
            this.currentViewMode = WidgetViewMode.FULLSCREEN;
        }
        if (dialogData && dialogData.selectedSymbol) {
            // this.tvChartContainer = 'tv_chart_container_fullscreen';
            this.selectedSymbol = dialogData.selectedSymbol;
            
            // this.getChartingOptions()
            //     .then((res: string[]) => this.getSelectedChartingType(res));
        }
        
        this.quoteService.getFeedSubject(QUOTE_UPDATE_TYPE.OHLC).subscribe(resData => {
            
            if (resData.responseId !== this.responseId) {
                return;
            }
            const res = resData.data;
            if (res && res.length) {
                this.chartData = this.cleanData(res.reverse());
                this.setupChart(this.chartData);

            }
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.mwSymbol?.currentValue) {
            // this.toggleChartMaximum();
            // this.getChartingOptions()
            //     .then((res: string[]) => this.getSelectedChartingType(res))
            //     .then((cache) => this._fetchSymbol(this.mwSymbol));

                this._fetchSymbol(this.mwSymbol)
        }
    }

    async ngAfterViewInit() {
        if (this.symbolId || (this.securityId && this.marketId)) {
                await this.getSymbolData();
                this.newWindowFetchSymbol(this.selectedSymbol)

        }

        // Chart must first fetch again whenever socket is re-connected to plot
        // lost data.
        // this.subscriptions.add(
        //     this._eventsService.subscribe(EVENTS.SOCKET_CONNECTED, data => {
        //         if (this.selectedSymbol && this.tradingViewOptions && this.tradingViewOptions.widget) {
        //             console.log('Socket reconnected, fetching charting data again..');
        //             this.tradingViewOptions.dataFeed.onResetCacheCallback();
        //             this.tradingViewOptions.widget.chart().resetData();
        //         }
        //     })
        // );


        // this.subscriptions.add(
        //     fromEvent(window, 'resize').pipe(throttle(ev => interval(1000))).subscribe(ev => {
        //         this.initOpts = {
        //             height: 0.6 * window.innerHeight
        //         }
        //         this._changeDetectorRef.detectChanges();
        //     })
        // )

    }

    // toggleChartMaximum() {
    //     this._widgetService.changeWidgetState({
    //         widgetName: FluidWidgets.chart,
    //         widgetState: WidgetViewMode.DEFAULT
    //     });
    //     this._eventsService.publish(EVENTS.MAXIMIZE_WIDGET_STATE, FluidWidgets.chart);
    // }


    getSymbolDetails(symbol: MarketWatch) {
        return new Promise((resolve, reject) => {
            if (symbol.symbol_id) {
                resolve(symbol);
            } else {
                this.marketwatchService.getMWStaticData(
                    {
                        ...(this.symbolId) && { symbol_id: this.symbolId },
                        ... (this.marketId && this.securityId) && { market_id: this.marketId, security_id: this.securityId, is_index: this.isIndex }
                    }).subscribe((response) => {
                        if (response) {
                            symbol = response;
                        }
                        resolve(symbol);
                    }, err => {
                        reject(symbol);
                    });
            }
        });
    }

    // getChartingOptions() {
    //     return new Promise((resolve, reject) => {
    //         this._chartService.getChartingOptions()
    //             .then((res: string[]) => {
    //                 // commenting as this was hardcoded for only handling chart iq
    //                 // if (res.length) {
    //                 //     res.sort();
    //                 //     if (res.includes(ChartLibrary.chartIq)) {
    //                 //         this.currentChartingLibrary = ChartLibrary.chartIq;
    //                 //     } else {
    //                 //         this.currentChartingLibrary = res[0];
    //                 //     }
    //                 // }
    //                 resolve(res);
    //             });
    //     });
    // }

    // getSelectedChartingType(options: string[]) {
    //     if (this.chartCache) { return this.chartCache };
    //     this.chartCache = new Promise((resolve, reject) => {
    //         share(),
    //             this._cacheService.getChartLibrary(CACHE_KEYS.chartingType).subscribe(cache => {
    //                 if (cache && options.indexOf(cache) !== -1) {
    //                     this.currentChartingLibrary = cache;
    //                 }
    //                 this.chartTypeLoaded = true;
    //                 resolve(cache);
    //             });
    //     });
    //     return this.chartCache;
    // }

    private _fetchSymbol(symbol) {
        if ((this.dialogData && this.dialogData.isDialog && this.selectedSymbol) || !(this.selectedSymbol &&
            (symbol.market_id === this.selectedSymbol.market_id && symbol.security_id === this.selectedSymbol.security_id))) {
            this.selectedSymbol = symbol;
            if (this.currentChartingLibrary === ChartLibrary.tradingView) {
                this._setupTradingView();
            } else if (this.currentChartingLibrary === ChartLibrary.echarts) {
                if (this.chartUpdateSubscribtion) {
                    this.chartUpdateSubscribtion.unsubscribe();
                }
                this.responseId = Date.now();
                this.chartFilters = {
                    security_id: symbol.security_id,
                    market_id: symbol.market_id,
                    candle_size: this.selectedInterval,
                    symbol_id: symbol.symbol_id,
                    from_date: Utils._getFromDate(this.selectedInterval, true),
                    to_date: Utils._getToDate(),
                    index: this.selectedSymbol.is_index,
                    instrument_name: ChartUtilities.getInstrumentName(this.selectedSymbol),
                    market_lot: this.selectedSymbol.market_lot,
                    scrip_precision: this.selectedSymbol.scrip_precision,
                    trade_value: this.selectedSymbol.trade_value,
                    is_market_movement_response: false,
                    responseId: this.responseId
                };

                this.chartUpdateSubscribtion = this._chartService
                    .subscribeCandles(symbol, this.selectedInterval).subscribe((candle: CandleUpdateObj) => {
                        if (candle.type === ChartUpdateType.update) {
                            this._updateChart(this._cleanSingleCandle(candle.data));
                        } else {
                            this._pushChartData(this._cleanSingleCandle(candle.data));
                        }
                    });

                this.firstFetch();
            }
        }
    }

    private _updateChart(updateData: any) {
        if (this.candleOptions && !this.candleOptions.xAxis[0].data.length) {
            this._pushChartData(updateData);
            return;
        }
        this.chartData.xAxis[this.chartData.xAxis.length - 1] = '' + updateData.xAxis;
        this.chartData.volumeData[this.chartData.volumeData.length - 1] = '' + updateData.volumeData;
        this.chartData.allCloses[this.chartData.allCloses.length - 1] = '' + updateData.allCloses;
        this.chartData.data[this.chartData.data.length - 1] = updateData.data;
        this.chartData.ohlc[this.chartData.ohlc.length - 1] = updateData.ohlc;
        this._setUpdatedData();
    }

    public openNewChartWindow() {
        if ((this.chartFilters && this.chartFilters.symbol_id) || this.currentChartingLibrary !== ChartLibrary.echarts) {
            // const url = `${window.location.origin}/chart/${this.selectedSymbol.symbol_id}`;
            const url = `${window.location.origin}/chart?symbolId=${this.selectedSymbol.symbol_id}&&isIndex=${this.selectedSymbol.is_index}`;
            window.open(url, '_blank');
        } else {
            this._toast.error('Select a symbol to open chart');
        }
    }
    private _setupTradingView() {
        function getParameterByName(name) {
            name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
            const regex = new RegExp('[\\?&]' + name + '=([^&#]*)'),
                results = regex.exec(location.search);
            return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '))
        }
        if (this.tradingViewOptions && this.tradingViewOptions.datafeed) {
            this.tradingViewOptions.datafeed.unsubscribeBars(null);
        }
        this.tradingViewOptions.dataFeed = new TradingViewDatafeed(this._chartService, this._symbolSearchService,
            this.quoteService, this.marketService, this.marketwatchService, this.remoteConfigService);
        this.tradingViewOptions.dataFeed.updateInstrument(Object.assign({}, this.selectedSymbol));
        // if formatted_symbol is not present, then use the formatted symbol from the symbol search service.
        // this is done majorly for mobile app.
        this.tradingViewOptions.widget = new widget({
            debug: false,
            symbol: this.selectedSymbol.symbol,
            interval: (StorageHelper.tradingViewInterval ?? 'D') as ResolutionString,
            container: this.tvChartContainer,
            locale: 'en',
            datafeed: this.tradingViewOptions.dataFeed,
            library_path: '/charting_library/',
            timezone: 'Asia/Kolkata',
            autosize: true,
            fullscreen: false,
            enabled_features: [
                'hide_left_toolbar_by_default',
                'header_in_fullscreen_mode',
                'side_toolbar_in_fullscreen_mode',
                'library_custom_color_themes',
            ],
            disabled_features: ['header_screenshot'],
            time_frames: [
                { text: '1d', resolution: '1' as ResolutionString, description: '1 Day' },
                { text: '5d', resolution: '60' as ResolutionString, description: '5 Days' },
                { text: '1m', resolution: 'D' as ResolutionString, description: '1 Month' },
                { text: '3m', resolution: 'D' as ResolutionString, description: '3 Months' },
                { text: '1y', resolution: 'D' as ResolutionString, description: '1 Year' },
                { text: '5y', resolution: '1M' as ResolutionString, description: '5 Years' },
            ],
            theme: 'light',
            custom_themes: getTradingViewCustomThemes(),
        });          
        // Subscribe to events on chart ready
        this.tradingViewOptions.widget.onChartReady(function () {
            // // Subscribe to interval changes
            this.activeChart().onIntervalChanged().subscribe(null, (interval, timeframeObj) => {
                // Update the interval in local storage
                StorageHelper.tradingViewInterval = interval;
            });
        });
    }

    private _setUpdatedData() {

        const _candleStickChartOption = {
            xAxis: [
                {
                    data: this.chartData.xAxis
                },
                {
                    data: this.chartData.xAxis
                }
            ],
            series: null
        };

        if (this.selectedChart === ChartTypes.candle) {
            _candleStickChartOption.series = [
                {
                    data: this.chartData.volumeData
                }, {
                    data: this.chartData.data,
                }
            ];
        } else if (this.selectedChart === ChartTypes.line) {
            _candleStickChartOption.series = [
                {
                    data: this.chartData.volumeData
                }, {
                    data: this.chartData.allCloses,
                }
            ];
        } else if (this.selectedChart === ChartTypes.area) {
            _candleStickChartOption.series = [
                {
                    data: this.chartData.volumeData
                }, {
                    data: this.chartData.allCloses,
                }
            ];
        } else {
            _candleStickChartOption.series = [
                {
                    data: this.chartData.volumeData
                }, {
                    data: this.chartData.ohlc,
                }
            ];
        }
        this.chartUpdate = _candleStickChartOption;
    }

    private _pushChartData(updateData: any) {
        this.chartData.xAxis.push('' + updateData.xAxis);
        this.chartData.volumeData.push('' + updateData.volumeData);
        this.chartData.allCloses.push('' + updateData.allCloses);
        this.chartData.data.push(updateData.data);
        this.chartData.ohlc.push(updateData.ohlc);
        this._setUpdatedData();
    }

    get intervals() {
        return Object.keys(this.chartIntervalEnums).filter(
            (type) => isNaN(<any>type) && type !== 'values'
        );
    }

    get charts() {
        return Object.values(this.chartTypesEnum);
    }

    firstFetch() {
        this._chartService.getChartingData(this.chartFilters);
    }

    cleanData(data: ChartDataResponse[]): ChartData {
        const arrayOfOHLC = [];
        const xAxis: string[] = [];
        const volumes: string[] = [];
        const allCloses: string[] = [];
        const ohlc = [];
        const textdate = [];
        data.sort((a, b) => {
            const atime = (new Date(a.timestamp)).getTime();
            const btime = (new Date(b.timestamp)).getTime();
            return atime - btime;
        });
        for (let i = 0; i < data.length; i++) {
            const date = new Date(Utils.istToGmt(data[i].timestamp));

            // Array of ohlc data (open close low high)
            arrayOfOHLC.push([data[i].open_price, data[i].close_price, data[i].low_price, data[i].high_price]);

            // let dateValue = (date.getHours().toString().length < 2 ? '0' : '') + date.getHours().toString();
            // dateValue += ':';
            // dateValue += (date.getMinutes().toString().length < 2 ? '0' : '') + date.getMinutes().toString();
            const dateValue = date.toLocaleString();

            textdate.push(date);
            // Array of time to show in x axis
            xAxis.push(dateValue);

            // Array of volumes for volume chart
            volumes.push('' + data[i].volume);

            // Array of close prices
            allCloses.push('' + data[i].close_price);
            ohlc.push([i, '' + data[i].open_price, '' + data[i].close_price, '' + data[i].low_price, '' + data[i].high_price]);
        }
        return { data: arrayOfOHLC, xAxis: xAxis, volumeData: volumes, allCloses: allCloses, ohlc: ohlc };
    }

    private _cleanSingleCandle(data: ChartDataResponse): ChartUpdate {
        const date = new Date(data.timestamp);
        const OHLCdata = ['' + data.open_price, '' + data.close_price, '' + data.low_price, '' + data.high_price];
        const textdate = [];
        // let dateValue = (date.getHours().toString().length < 2 ? '0' : '') + date.getHours().toString();
        // dateValue += ':';
        // dateValue += (date.getMinutes().toString().length < 2 ? '0' : '') + date.getMinutes().toString();
        const dateValue = date.toLocaleString();

        textdate.push(date);
        // Array of time to show in x axis
        const xAxis = dateValue;

        // Array of volumes for volume chart
        const volumes = '' + data.volume;

        // Array of close prices
        const allCloses = '' + data.close_price;
        const ohlc = [
            this.chartData.data.length ? this.chartData.data.length - 1 : 0,
            '' + data.open_price,
            '' + data.close_price,
            '' + data.low_price,
            '' + data.high_price
        ];

        return {
            data: OHLCdata, xAxis: xAxis, volumeData: volumes, allCloses: allCloses, ohlc: ohlc
        };
    }

    changeInterval(newInterval) {
        this.selectedInterval = newInterval;
        this.chartFilters.candle_size = newInterval;
        this.chartFilters.from_date = Utils._getFromDate(this.selectedInterval);
        this.chartFilters.to_date = Utils._getToDate();
        this._chartService.changeSubscribedInterval(newInterval);
        this.firstFetch();
    }

    ngOnInit() {
        /** Checking if chart is opened in new tab or not */
        if (this.symbolId || (this.securityId && this.marketId)) {
            this.openedInNewTab = true;
        }
    }

    getSymbolData() {
        return new Promise((resolve, reject) => {
            this.marketwatchService.getMWStaticData({
                ...(this.symbolId) && { symbol_id: this.symbolId },
                ... (this.marketId && this.securityId) && { market_id: this.marketId, security_id: this.securityId, is_index: this.isIndex }
            }).subscribe((response) => {
                if (response) {
                    let symbolObj: MarketWatch = null;
                    if ((response.symbol_id === +this.symbolId || (response.market_id === parseInt(this.marketId) &&
                        response.security_id === +(this.securityId)))) {
                        symbolObj = new MarketWatch(response);
                        this.selectedSymbol = symbolObj;
                    } else {
                        symbolObj = new MarketWatch();
                    }

                    this.symbolId = symbolObj.symbol_id;

                    resolve(symbolObj);
                }
            });
        });
    }

    newWindowFetchSymbol(symbolObj: MarketWatch) {

        if (this.currentChartingLibrary === ChartLibrary.echarts) {
            this.responseId = Date.now();
            this.chartFilters = {
                candle_size: this.selectedInterval,
                symbol_id: this.symbolId,
                from_date: Utils._getFromDate(this.selectedInterval),
                to_date: Utils._getToDate(),
                index: this.selectedSymbol.is_index,
                market_id: this.selectedSymbol.market_id,
                instrument_name: ChartUtilities.getInstrumentName(this.selectedSymbol),
                market_lot: this.selectedSymbol.market_lot,
                scrip_precision: this.selectedSymbol.scrip_precision,
                trade_value: this.selectedSymbol.trade_value,
                is_market_movement_response: false,
                responseId: this.responseId
            };

            /**
             * Code Below is commented because QA does not has latest HFt build
             */

            // const symbolInfoRequestParams: SymbolInfoParams = {
            //     symbol_id: this.symbolId
            // };

            // this._symbolInfoService.getSymbolInfo(symbolInfoRequestParams)
            //     .subscribe(response => {
            //         if (response) {
            //             symbolObj = new MarketWatch(response);
            //         }
            //         symbolObj['symbol_id'] = +this.symbolId;
            //         this.selectedSymbol = symbolObj;
            //         symbolObj.symbol_id = +this.symbolId;
            //         this.chartUpdateSubscribtion = this._chartService
            //             .subscribeCandels(symbolObj, this.selectedInterval).subscribe((candle: CandleUpdateObj) => {
            //                 if (candle.type === ChartUpdateType.update) {
            //                     this._updateChart(this._cleanSingleCandle(candle.data));
            //                 } else {
            //                     this._pushChartData(this._cleanSingleCandle(candle.data));
            //                 }
            //             });
            //         this.firstFetch();
            //     });


            this.chartUpdateSubscribtion = this._chartService
                .subscribeCandles(symbolObj, this.selectedInterval).subscribe((candle: CandleUpdateObj) => {
                    if (candle.type === ChartUpdateType.update) {
                        this._updateChart(this._cleanSingleCandle(candle.data));
                    } else {
                        this._pushChartData(this._cleanSingleCandle(candle.data));
                    }
                });
            this.firstFetch();
        } else if (this.currentChartingLibrary === ChartLibrary.tradingView) {
            this._setupTradingView();
        }
    }

    displayToolbar() {
        return !(this.currentChartingLibrary === this.chartLibrary.tradingView && this.symbolId)
            && this.currentChartingLibrary !== this.chartLibrary.chartIq;
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
        this._chartService.clearCache();
    }

    chartChange(chart) {
        this.selectedChart = chart;
        this.setupChart(this.chartData);
    }

    getZoomForRows(nRows: number) {
        const minVal = 20;
        const maxVal = 1000;
        const percentage = ((nRows - minVal) / (maxVal - minVal)) * 100;
        return percentage > 96 ? 96 : percentage;
    }

    setupChart(chartingData?: ChartData) {
        if (chartingData) {
            // chartingData = this.getMockData();
            // this.chartData = chartingData;
            const candleChartObj = new ChartTemplate(chartingData, this.selectedChart);
            this.candleOptions = candleChartObj.options;
            this.candleOptions.responsive = true;

            console.log(this.candleOptions);
            if (this.chartSelectectionSubscription) {
                this.chartSelectectionSubscription.unsubscribe();
            }
            this.chartSelectectionSubscription = candleChartObj.changeEmitter.subscribe(event => {
                this._changeDetectorRef.detectChanges();
            });
            if (this.symbolId) {
                this.candleOptions.grid = [
                    {
                        left: 20,
                        right: 70,
                        top: '10%',
                        height: '70%'
                    }, {
                        left: 20,
                        right: 70,
                        height: '20%',
                        bottom: 25
                    }
                ];
            } 
            // else if (this.selectedLayout === PersonalizeView.default) {
            //     // this.candleOptions.grid = [
            //     //     {
            //     //         left: 20,
            //     //         right: 30,
            //     //         top: 20,
            //     //         height: 'auto'
            //     //     }, {
            //     //         left: 20,
            //     //         right: 30,
            //     //         height: 40,
            //     //         top: 'auto'
            //     //     }
            //     // ];
            //     this.candleOptions.grid = [
            //         {
            //             left: 20,
            //             right: 50,
            //             top: '10%',
            //             height: '65%'
            //         }, {
            //             left: 20,
            //             right: 50,
            //             height: '10%',
            //             bottom: 25
            //         }
            //     ];
            this.chartSelection = candleChartObj.chartSelection;
        }
    }

    // getMockData(): ChartData {
    //     // Convert data from {} to []
    //     const arrayOfOHLC = [];
    //     const xAxis: string[] = [];
    //     const volumes: string[] = [];
    //     const allCloses: string[] = [];
    //     const ohlc = [];
    //     ohlcData.sort((a, b) => {
    //         const atime = (new Date(a.timestamp)).getTime();
    //         const btime = (new Date(b.timestamp)).getTime();
    //         return atime - btime;
    //     });
    //     for (let i = 0; i < ohlcData.length; i++) {
    //         const date = new Date(ohlcData[i].timestamp);
    //         // Array of ohlc data (open close low high)
    //         arrayOfOHLC.push([ohlcData[i].open, ohlcData[i].close, ohlcData[i].min, ohlcData[i].max]);

    //         let dateValue = (date.getHours().toString().length < 2 ? '0' : '') + date.getHours().toString();
    //         dateValue += ':';
    //         dateValue += (date.getMinutes().toString().length < 2 ? '0' : '') + date.getMinutes().toString();
    //         // Array of time to show in x axis
    //         xAxis.push(dateValue);

    //         // Array of volumens for volume chart
    //         volumes.push(ohlcData[i].volume);

    //         // Array of close prices
    //         allCloses.push(ohlcData[i].close);

    //         ohlc.push([i, ohlcData[i].open, ohlcData[i].close, ohlcData[i].min, ohlcData[i].max]);
    //     }
    //     return { data: arrayOfOHLC, xAxis: xAxis, volumeData: volumes, allCloses: allCloses, ohlc: ohlc };
    // }

    // isFullScreen() {
    //     return this.currentViewMode === WidgetViewMode.FULLSCREEN;
    // }

    // Commented in case we need dialog approach again.
    // openDialog() {
    //     const dialogRef = this._dialog.open(ChartingComponent, {
    //         panelClass: 'full-screen-dialog',
    //         data: {
    //             isDialog: true,
    //             selectedSymbol: this.selectedSymbol
    //         },
    //         position: {
    //             top: '64px'
    //         },
    //         disableClose: true,
    //         hasBackdrop: true,
    //         backdropClass: 'full-screen-backdrop'
    //     });
    //     this._fullScreenDialog.saveDialog(dialogRef);
    //     dialogRef.afterClosed().subscribe(() => {
    //         this.currentViewMode = WidgetViewMode.DEFAULT;
    //     })
    // }

    // closeDialog() {
    //     this._fullScreenDialog.closeDialog();
    // }
}
